import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDownLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M35.7498 7.06298C35.7498 6.44417 36.2561 5.93787 36.8749 5.93787C37.4937 5.93787 38 6.44417 38 7.06298V19.4392C38 22.5473 35.4826 25.0647 32.3744 25.0647H5.83592L12.9171 32.1459C13.3531 32.5819 13.3531 33.2991 12.9171 33.7351C12.4811 34.1711 11.7638 34.1711 11.3279 33.7351L2.32699 24.7342C1.891 24.2983 1.891 23.581 2.32699 23.145L11.3279 14.1441C11.7638 13.7082 12.4811 13.7082 12.9171 14.1441C13.3531 14.5801 13.3531 15.2974 12.9171 15.7334L5.83592 22.8145H32.3744C34.2379 22.8145 35.7498 21.3026 35.7498 19.4392V7.06298Z" })
});
export default SvgArrowDownLeft;
